module.exports = __webpack_public_path__ + "static/media/logo.896c69c9.svg";